import { render } from "./PageApplicationsItem.vue?vue&type=template&id=08c99574"
import script from "./PageApplicationsItem.vue?vue&type=script&lang=js"
export * from "./PageApplicationsItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__